Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.FilterView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/filter"]

  humanize: false
  addMissing: false
  selectAll: false

  visibleInMyHistorySession: true

  events:
    'click .apply': 'apply'
    'click .select_all_filter': 'selectAllFilters'
    'click .filter-title': 'onToggleExpand'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facet = @options.facet
    @tagsByClientCode = @options.tagsByClientCode

  destroy: ->
    this.remove()
    return false

  render: ->
    if @_shouldShow() and not @mustHide()
      @$el.html @template
        facets: @_terms()
        self: @
      _.defer @_renderTooltip
    @

  getFacet: ->
    @facet[@facetName]

  _shouldShow: ->
    facet = @getFacet()
    @getAppliedValues().length == 0 and facet and facet['terms'].length > 0

  _terms: ->
    facet = @getFacet()
    terms = _.clone(facet['terms'])
    terms.sort @orderBy if @orderBy
    @addCustomValues(terms, facet)
    terms

  _filterName: ->
    I18n.t(
      "monitoring.dashboard.filters.filter_names.#{@name}"
      defaultValue: @alias or _.str.capitalize(@name)
    )

  _renderTooltip: =>
    $titleText = @$('.filter-title-text')
    return unless @_hasOverflow $titleText
    $titleText.attr('title', @_filterName())

  _hasOverflow: ($selector) ->
    $selector[0]?.offsetWidth < $selector[0]?.scrollWidth

  isLazy: ->
    @getFacet()?.lazy

  addCustomValues: (terms, facet) ->
    terms.push({ term: "No #{@alias || @name}", count: facet['missing'], custom: true }) if @addMissing && facet['missing'] > 0

  getDescription: (facet) ->
    facet.term

  onToggleExpand: =>
    if @$el.find('.filter').hasClass('expanded')
      @$el.find('.select_all_filter').addClass('hidden')
    else
      @$el.find('.select_all_filter').removeClass('hidden')

  selectAllFilters: (event) =>
    event.stopPropagation()
    checkbox = @$el.find('input[type=checkbox]')
    if @$el.find('input[type=checkbox]:checked').length == checkbox.length
      checkbox.prop('checked', false)
    else
      checkbox.prop('checked', true)

  apply: =>
    for term in @$el.find('input[type=checkbox]')
      if term.checked
        @addFilter(term.value)
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  mustHide: ->
    not @visibleInMyHistorySession and @inMyHistorySession()

  inMyHistorySession: ->
    $('li.active a span #name').text() == 'My History'
